<script>
const timeOptions = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
export default {
  name: "driverWithdrawal",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      form: {
        windowPhase: [],
        applyEnd: "",
        applyStart: "",
        earningsFreeze: 2,
        applyAmountMin: 0,
      },
      checkAll: false,
      isIndeterminate: false,
      disabled: true,
      oldData: {}
    };
  },
  computed: {
    rules() {
      return {
        earningsFreeze: [
          { required: true, message: "请选择收益冻结期", trigger: "change" },
        ],
        earningsFreezeTime: [
          {
            required: this.form.earningsFreeze == 1,
            message: "请输入收益冻结",
            trigger: "blur",
          },
        ],
        windowPhase: [
          { required: true, message: "请选择提现日期窗口", trigger: "change" },
        ],
        applyStart: [
          { required: true, message: "请选择提现时间窗口", trigger: "change" },
        ],
        applyEnd: [
          { required: true, message: "请选择提现时间窗口", trigger: "change" },
        ],
        applyNum: [
          { required: true, message: "请输入每日提现次数", trigger: "change" },
        ],
        applyAmountMin: [
          { required: true, message: "请输入单次提现限额", trigger: "change" },
        ],
        applyAmountMax: [
          { required: true, message: "请输入单次提现限额", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (Number(value) < Number(this.form.applyAmountMin)) {
                callback(new Error("单次提现限额不能大于每日提现限额"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      };
    },
    routeName() {
      return this.$route.name;
    },

  },
  watch: {
    rowData: {
      handler(newVal) {

        if (!newVal) {
          return
        }
        this.form = {
          ...newVal,
          earningsFreeze: newVal.earningsFreeze || 2,
          windowPhase: newVal.windowPhase
            ? newVal.windowPhase.split("、")
            : [],
          applyStart: newVal.applyStartTime ? newVal.applyStartTime : '00:00',
          applyEnd: newVal.applyEndTime ? newVal.applyEndTime : '23:00',
          applyNum: newVal.applyNum || 1,
        };
        this.oldData = { ...this.form }
        this.check(this.form.windowPhase);
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      },
    },
  },
  methods: {
    handleCheckAllChange(val) {
      this.form.windowPhase = val ? timeOptions : [];
      this.isIndeterminate = false;
    },
    check(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === timeOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < timeOptions.length;
    },
    cancelForm() {
      this.form = { ...this.oldData }
      this.disabled = true
    },
    saveClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          const sortedDaysOfWeek = this.form.windowPhase.sort((a, b) => {
            const week = {
              周一: 1,
              周二: 2,
              周三: 3,
              周四: 4,
              周五: 5,
              周六: 6,
              周日: 7,
            };
            return week[a] - week[b];
          });
          let url = "/api/v1/manage/hitchRide/withdrawalConfig";
          let data = await this.$axios.post(url, {
            ...this.form,
            windowPhase: sortedDaysOfWeek.join("、"),
            applyStartTime: this.form.applyStart,
            applyEndTime: this.form.applyEnd,
          });
          if (data && data.code === 1) {
            this.$message.success("保存成功");
            this.disabled = true;
            this.$emit('refresh')
          }
          this.loading = false
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
  },
};
</script>

<template>
  <div class="driverWithdrawal">
    <div class="flex-between">
      <div class="formTitle">收益冻结</div>
      <template v-if="btnPreFn(routeName + '_edit', false)">
        <el-button type="primary" v-if="disabled" @click="disabled = false">编辑</el-button>
        <div v-else>
          <el-button @click="cancelForm">取消</el-button>
          <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        </div>
      </template>
    </div>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="left" :disabled="disabled"
      style="width: 700px;">
      <el-form-item label="收益冻结" prop="earningsFreeze">
        <div class="flex-start">
          <el-switch v-model="form.earningsFreeze" :active-value="1" :inactive-value="2"></el-switch>
          <span class="util-remark" style="margin-left: 10px;">如关闭，则订单完成后车费立即入账</span>
        </div>
      </el-form-item>
      <el-form-item label="冻结时长" prop="earningsFreezeTime">
        <el-input v-model="form.earningsFreezeTime" maxlength="6" v-input-filter="{ min: 1, max: 31, precision: 0 }"
          placeholder="最低收益冻结期" :disabled="form.earningsFreeze == 2">
          <template slot="prepend">订单收益冻结</template>
          <template slot="append">天</template>
        </el-input>
      </el-form-item>
      <div class="formTitle">提现窗口</div>
      <el-form-item label="提现窗口" prop="windowPhase">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
        </el-checkbox>
        <el-checkbox-group @change="check" v-model="form.windowPhase">
          <el-checkbox label="周一">周一</el-checkbox>
          <el-checkbox label="周二">周二</el-checkbox>
          <el-checkbox label="周三">周三</el-checkbox>
          <el-checkbox label="周四">周四</el-checkbox>
          <el-checkbox label="周五">周五</el-checkbox>
          <el-checkbox label="周六">周六</el-checkbox>
          <el-checkbox label="周日">周日</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="提现时间" required>
        <div style="display: flex;">
          <el-form-item label="" prop="applyStart" style="flex: 1;">
            <el-time-select placeholder="起始时间" v-model="form.applyStart" :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '23:00',
              maxTime: form.applyEnd
            }">
            </el-time-select>
          </el-form-item>

          <span style="margin: 0 10px;">至</span>
          <el-form-item label="" prop="applyEnd" style="flex: 1;">
            <el-time-select placeholder="起始时间" v-model="form.applyEnd" :picker-options="{
              start: '00:00',
              step: '01:00',
              end: '23:00',
              minTime: form.applyStart
            }">
            </el-time-select>
          </el-form-item>
        </div>
      </el-form-item>

      <el-form-item label="提现次数" prop="applyNum">
        <el-input v-input-filter="{ min: 1, max: 10, precision: 0 }" v-model="form.applyNum" placeholder="请输入每日提现次数">
          <template slot="prepend">每日可申请提现</template>
          <template slot="append">次</template>
        </el-input>
      </el-form-item>
      <el-form-item label="单次限额" required>
        <div class="flex-start">
          <el-form-item style="margin-bottom: 0; flex: 1;" label="" label-width="0px" prop="applyAmountMin" >
            <el-input v-input-filter="{ min: 1, max: 999999, precision: 0 }" v-model="form.applyAmountMin"
              placeholder="">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <span style="padding: 0 10px">至</span>
          <el-form-item style="margin-bottom: 0; flex: 1;" label="" label-width="0px" prop="applyAmountMax">
            <el-input v-input-filter="{ min: 1, max: 999999, precision: 0 }" v-model="form.applyAmountMax"
              placeholder="">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped lang="less">
.driverWithdrawal {
  width: 700px;

  /deep/ .el-input-group__append,
  .el-input-group__prepend {
    background-color: #F5F7FA !important;
  }
}
</style>
